import { defineComponent, reactive, watch, nextTick, computed, ref, onMounted } from 'vue';
import moment from 'moment';
import { withLoading } from '@hems/component';
import LogicalCanvas from '@hems/component/src/mapper/canvas/LogicalCanvas.vue';
import PhysicalCanvas from '@hems/component/src/mapper/canvas/PhysicalCanvasHome.vue';
import { Helper } from '@hems/util';
import { NUMBER_UNIT } from '@hems/util/src/constant';
import { MAPPER_APP_TYPE, MAPPER_PERIOD_DATA, MAPPER_POWER_DEFAULT_VALUE } from '@hems/util/src/constant/mapper';
export default defineComponent({
    name: 'SmartModuleMobileHomeContainerDemo',
    components: {
        PhysicalCanvas,
        LogicalCanvas,
    },
    props: {
        width: {
            type: Number,
            default: 0,
        },
        height: {
            type: Number,
            default: 0,
        },
        selectedDate: {
            type: String,
            default: '',
        },
    },
    emits: ['changeDateMode', 'openWebCalendar'],
    setup(props, { emit }) {
        const DEMO_DATE = '20240430';
        const PADDING = 49;
        const COMBINER_ID = '342611100003A01001';
        const state = reactive({
            logicalData: { combinerId: '', deviceIdList: [] },
            tabName: 'roof',
            height: props.height ? props.height - PADDING : window.innerHeight - PADDING,
            moduleEnergyData: [],
            module15minPwData: [],
            dateType: MAPPER_PERIOD_DATA.DAY,
            physicalData: '',
        });
        const isLoad = ref(false);
        function rerender() {
            isLoad.value = false;
            nextTick(() => (isLoad.value = true));
        }
        const isRoofShow = computed(() => state.tabName === 'roof' && isLoad.value);
        const onLoad = async () => {
            withLoading(async () => {
                try {
                    const data = await import('@hems/user/src/mobileviews/demojson/edited_physical_data.json');
                    state.physicalData = data.default;
                }
                catch (error) {
                    console.log(error);
                }
            })();
        };
        const loadModulesInfo = async () => {
            withLoading(async () => {
                try {
                    const data = await import('@hems/user/src/mobileviews/demojson/mi-profile.json');
                    if (data.default && data.default.length > 0) {
                        state.logicalData = {
                            combinerId: COMBINER_ID,
                            deviceIdList: data.default.map((info) => ({ deviceId: info.device_id, moduleId: info.module_id })),
                        };
                    }
                }
                catch (error) {
                    console.log(error);
                }
            })();
        };
        const totalPowerValue = ref(MAPPER_POWER_DEFAULT_VALUE);
        const loadEnergyData = async () => {
            withLoading(async () => {
                try {
                    let data;
                    if (state.dateType === MAPPER_PERIOD_DATA.DAY) {
                        data = await import('@hems/user/src/mobileviews/demojson/edited_daily.json');
                    }
                    else if (state.dateType === MAPPER_PERIOD_DATA.MONTH) {
                        data = await import('@hems/user/src/mobileviews/demojson/edited_monthly.json');
                    }
                    else if (state.dateType === MAPPER_PERIOD_DATA.YEAR) {
                        data = await import('@hems/user/src/mobileviews/demojson/edited_yearly.json');
                    }
                    else if (state.dateType === MAPPER_PERIOD_DATA.LIFETIME) {
                        data = await import('@hems/user/src/mobileviews/demojson/edited_lifetime.json');
                    }
                    await new Promise((resolve) => setTimeout(resolve, 0));
                    if (data) {
                        state.moduleEnergyData = data.default.map((item) => ({
                            device_id: item.device_id,
                            total_power: item.total_power,
                        }));
                        totalPowerValue.value = Helper.getKwhData(state.moduleEnergyData.map((data) => data.total_power / NUMBER_UNIT.THOUSAND));
                    }
                }
                catch (error) {
                    console.log(error);
                }
            })();
        };
        const load15MinPowerData = () => {
            if (state.dateType === MAPPER_PERIOD_DATA.DAY) {
                withLoading(async () => {
                    try {
                        const data = await import('@hems/user/src/mobileviews/demojson/edited_timeline.json');
                        state.module15minPwData = data.default.filter((moduleData) => (moduleData.colec_dt = Number(moment(moduleData.colec_dt).format('YYYYMMDDHHmm'))));
                    }
                    catch (error) {
                        console.log(error);
                    }
                })();
            }
        };
        function changeDateMode(value) {
            state.dateType = value;
        }
        function onClickTab(tabName) {
            state.tabName = tabName;
            state.dateType = MAPPER_PERIOD_DATA.DAY;
        }
        const openCalendar = () => {
            if (state.dateType !== MAPPER_PERIOD_DATA.LIFETIME) {
                if (location.href.includes('/mobile/')) {
                    return;
                }
                emit('openWebCalendar', state.dateType);
                return;
            }
        };
        watch(() => state.physicalData, () => {
            rerender();
        });
        watch(() => state.dateType, () => {
            loadEnergyData();
        });
        onMounted(async () => {
            await onLoad();
            await loadModulesInfo();
            await loadEnergyData();
            load15MinPowerData();
        });
        return {
            state,
            onClickTab,
            changeDateMode,
            openCalendar,
            totalPowerValue,
            MAPPER_APP_TYPE,
            isLoad,
            isRoofShow,
            DEMO_DATE,
        };
    },
});
